import { FirstTimeRegistration } from '@/components/elements/FirstTimeRegistration';
import { HeroImage } from '@/components/elements/HeroImage';
import { LoginForm } from '@/components/elements/LoginForm';
import { PageSection } from '@/components/elements/PageSection';
import { ServiceDescription } from '@/components/elements/ServiceDescription';
import { SharedDeviceLoginForm } from '@/components/elements/SharedDeviceLoginForm';
import { TodayAvailability } from '@/components/elements/TodayAvailability';
import { MainLayout } from '@/components/layouts/MainLayout';
import { ShareDeviceLayout } from '@/components/layouts/ShareDeviceLayout';
import { ROUTE_PATH } from '@/constants/routes';
import { useSuiteLoungeFlow } from '@/hooks/useSuiteLoungeFlow';
import { parseSubdomain } from '@/utils/subdomainParser';

export const Login = () => {
  const { withEntry } = useSuiteLoungeFlow();

  // サブドメインを検出
  const subdomainInfo = parseSubdomain(window.location.hostname);

  // サブドメインがある場合は共有端末用のログイン画面を表示
  if (subdomainInfo) {
    return (
      <ShareDeviceLayout>
        <SharedDeviceLoginForm />
      </ShareDeviceLayout>
    );
  }

  const signUpConfirmPath = withEntry(ROUTE_PATH.SIGN_UP_CONFIRM);

  // サブドメインがない場合は個人端末用のログイン画面を表示
  return (
    <MainLayout pageClassName="p-auth page_a1" showHeader={false}>
      <PageSection>
        <HeroImage src="/A_1_Title.jpg" alt="LOUNGE RESERVATION" />
        <div className="l-grid">
          <LoginForm />
          <FirstTimeRegistration linkTo={signUpConfirmPath} />
          <TodayAvailability />
          <ServiceDescription />
        </div>
      </PageSection>
    </MainLayout>
  );
};
